import { useState } from 'react'

// antd
import { MdDelete } from 'react-icons/md'
import { RiEditFill } from 'react-icons/ri'
import { PlusOutlined } from '@ant-design/icons'
import { Col, Divider, Row, Tag, Tooltip, Typography } from 'antd'

// components
import EducationForm from './educationForm'

// assets
import { useDispatch, useSelector } from 'react-redux'
import { removeEducationDraft } from '../../store/applicationDraft.slice'
import { formatDate } from '../../../../../utils/commonUtils'

const { Title, Text } = Typography
const EducationSection = () => {
    const [editData, setEditData] = useState(null)
    const [showEductionForm, setShowEducationForm] = useState(false)

    const dispatch = useDispatch()

    const { education } = useSelector((state) => state.applicationDraftSlice)

    return (
        <div>
            <div style={{ marginTop: '15px' }}>
                <div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginBottom: '10px',
                        }}
                    >
                        <Title level={5}>Education (Optional)</Title>
                        <Tooltip title="Add Education">
                            <button
                                type="button"
                                className="section-add-btn"
                                onClick={() => {
                                    setShowEducationForm(true)
                                    setEditData(null)
                                }}
                            >
                                <PlusOutlined style={{ fontSize: '15px' }} />
                            </button>
                        </Tooltip>
                    </div>
                    {education?.length > 0 && (
                        <div style={{ marginTop: '15px' }}>
                            {education?.map((e) => {
                                const isEditing =
                                    editData !== null &&
                                    editData?._tempId === e?._tempId &&
                                    showEductionForm
                                return isEditing ? (
                                    <div
                                        style={{
                                            marginBottom: '20px',
                                        }}
                                    >
                                        <EducationForm
                                            onCancel={setShowEducationForm}
                                            currentData={editData}
                                        />
                                    </div>
                                ) : (
                                    <Row gutter={25} key={e._tempId}>
                                        <Col
                                            xs={4}
                                            sm={4}
                                            md={4}
                                            lg={4}
                                            xl={4}
                                            style={{
                                                border: '1px solid #f0f0f0 ',
                                                padding: '10px',
                                                height: '100%',
                                                borderRadius: '8px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <div className="educationSvgLogo" />
                                        </Col>
                                        <Col
                                            xs={20}
                                            sm={20}
                                            md={20}
                                            lg={20}
                                            xl={20}
                                        >
                                            <div>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        columnGap: '10px',
                                                        justifyContent:
                                                            'space-between',
                                                    }}
                                                >
                                                    <Title level={5}>
                                                        {e?.degree?.label ||
                                                            '-'}
                                                    </Title>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            columnGap: '10px',
                                                        }}
                                                    >
                                                        <Tooltip title="Edit Education">
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => {
                                                                    setShowEducationForm(
                                                                        true
                                                                    )
                                                                    setEditData(
                                                                        e
                                                                    )
                                                                }}
                                                            >
                                                                <RiEditFill
                                                                    size={20}
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                        <Tooltip title="Delete Education">
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() => {
                                                                    dispatch(
                                                                        removeEducationDraft(
                                                                            e?._tempId
                                                                        )
                                                                    )
                                                                }}
                                                            >
                                                                <MdDelete
                                                                    size={20}
                                                                />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: '5px' }}>
                                                <Text
                                                    style={{
                                                        fontSize: '14px',
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    {e?.fieldOfStudy?.label ||
                                                        '-'}
                                                </Text>
                                                <Text
                                                    style={{
                                                        fontSize: '14px',
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    |
                                                </Text>
                                                <Text
                                                    style={{
                                                        fontSize: '14px',
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    {e?.institute?.label}
                                                </Text>
                                                <Text
                                                    style={{
                                                        fontSize: '14px',
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    |
                                                </Text>
                                                <Text
                                                    style={{
                                                        fontSize: '14px',
                                                        marginRight: '10px',
                                                    }}
                                                >
                                                    {e?.location || '-'}
                                                </Text>
                                            </div>
                                            <div style={{ marginTop: '5px' }}>
                                                {(() => {
                                                    const startLabel =
                                                        formatDate(e?.startDate)
                                                    const endLabel =
                                                        e.currentStudy
                                                            ? 'Present'
                                                            : formatDate(
                                                                  e?.endDate
                                                              )
                                                    if (
                                                        !startLabel &&
                                                        !endLabel
                                                    )
                                                        return null
                                                    return (
                                                        <>
                                                            {startLabel ? (
                                                                <Text
                                                                    style={{
                                                                        color: '#7a7a7aff',
                                                                        fontSize:
                                                                            '16px',
                                                                    }}
                                                                >
                                                                    {
                                                                        startLabel
                                                                    }
                                                                </Text>
                                                            ) : null}
                                                            {startLabel &&
                                                            endLabel ? (
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '14px',
                                                                        marginRight:
                                                                            '10px',
                                                                        marginLeft:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    -
                                                                </Text>
                                                            ) : null}
                                                            {endLabel ? (
                                                                <Text
                                                                    style={{
                                                                        color: e.currentStudy
                                                                            ? '#b9b9b9'
                                                                            : '#7a7a7aff',
                                                                        fontSize:
                                                                            '16px',
                                                                    }}
                                                                >
                                                                    {endLabel}
                                                                </Text>
                                                            ) : null}
                                                        </>
                                                    )
                                                })()}
                                            </div>
                                            <div>
                                                {e?.skills?.length > 0 && (
                                                    <>
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '10px',
                                                            }}
                                                        >
                                                            <div>
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '18px',
                                                                    }}
                                                                >
                                                                    Skills
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <Row gutter={10}>
                                                            {e?.skills?.map(
                                                                (
                                                                    skill,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <Tag
                                                                            key={
                                                                                index
                                                                            }
                                                                            bordered={
                                                                                false
                                                                            }
                                                                            color="processing"
                                                                            style={{
                                                                                marginTop:
                                                                                    '5px',
                                                                                cursor: 'auto',
                                                                            }}
                                                                        >
                                                                            {
                                                                                skill?.label
                                                                            }
                                                                        </Tag>
                                                                    )
                                                                }
                                                            )}
                                                        </Row>
                                                    </>
                                                )}
                                            </div>

                                            <div>
                                                {e?.tools?.length > 0 && (
                                                    <>
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '10px',
                                                            }}
                                                        >
                                                            <div>
                                                                <Text
                                                                    style={{
                                                                        fontSize:
                                                                            '18px',
                                                                    }}
                                                                >
                                                                    Tools
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        <Row gutter={10}>
                                                            {e?.tools?.map(
                                                                (
                                                                    data,
                                                                    index
                                                                ) => {
                                                                    return (
                                                                        <Tag
                                                                            key={
                                                                                index
                                                                            }
                                                                            bordered={
                                                                                false
                                                                            }
                                                                            color="processing"
                                                                            style={{
                                                                                marginTop:
                                                                                    '5px',
                                                                                cursor: 'auto',
                                                                            }}
                                                                        >
                                                                            {
                                                                                data?.label
                                                                            }
                                                                        </Tag>
                                                                    )
                                                                }
                                                            )}
                                                        </Row>
                                                    </>
                                                )}
                                            </div>
                                        </Col>
                                        <Divider />
                                    </Row>
                                )
                            })}
                        </div>
                    )}
                    {showEductionForm && editData === null && (
                        <EducationForm
                            onCancel={() => setShowEducationForm(false)}
                            currentData={null}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export default EducationSection
